import { render } from "./AspirationsSection.vue?vue&type=template&id=3a83449e&scoped=true"
import script from "./AspirationsSection.vue?vue&type=script&lang=js"
export * from "./AspirationsSection.vue?vue&type=script&lang=js"

import "./AspirationsSection.vue?vue&type=style&index=0&id=3a83449e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a83449e"]])

export default __exports__